import React from "react";
import {
 Box,
 Text,
 HStack,
 VStack,
 Image,
 Flex,
 Icon,
 Button,
} from "@chakra-ui/react";
import { MdPlace } from "react-icons/md";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const CollegeList = ({ collegeData }) => {
 const { country: paramCountry } = useParams();
 const location = useLocation();
 const navigate = useNavigate();

 // Extract country from pathname if available
 const pathSegments = location.pathname.split("/"); // ['', 'abroad-mbbs', 'nepal']
 const pathCountry = pathSegments[2];

 // Final country to use
 const country = paramCountry || pathCountry;

 console.log("Resolved country:", country);

 return (
  <Box>
   {collegeData.map((university) => (
    <Box
     key={university.id}
     display={"flex"}
     flexDirection={"column"}
     alignItems={"center"}
     justifyContent={"center"}
     marginBottom={"4vh"}
     marginLeft={{ lg: "1vw" }}
     marginTop={4}
    >
     <Box
      borderWidth="1px"
      border={"2px solid #01B4EC"}
      borderRadius="35px"
      overflow="hidden"
      p={4}
      bg="white"
      width={{ base: "100vw", lg: "70vw" }}
      margin={"auto"}
      position={"relative"}
      fontFamily={"Lato"}
      cursor={"pointer"}
      boxShadow="rgba(0, 0, 0, 0.7) 5px 7px 8px"
      transition="transform 0.3s ease"
      _hover={{
       transform: "translate(15px, 15px)",
      }}
     >
      <HStack>
       <VStack ml={{ base: "1vw", lg: "3vw" }}>
        <Image
         src={university.image2 || "https://via.placeholder.com/150"}
         alt={university.collegename}
         boxSize="150px"
         objectFit="cover"
        />
       </VStack>

       <VStack width={"45vw"} textAlign={"center"}>
        <Text
         color={"#01B4EC"}
         fontSize={{ base: "0.8rem", lg: "1rem" }}
         fontWeight="bold"
        >
         {university.collegename}
        </Text>
        <Flex
         align="center"
         fontSize={{ base: "0.7rem", lg: "1rem" }}
         color={"black"}
         fontWeight={"200"}
         opacity={"0.7"}
        >
         <Icon as={MdPlace} boxSize={30} />
         <Text>{university.address},</Text>
         <Text ml={1}>{university.state}</Text>
        </Flex>
        <Box bg="gray.200" p={2} borderRadius="md">
         <Text fontSize={{ base: "0.6rem", lg: "1rem" }} textAlign={"start"}>
          <strong>Courses Offered:</strong>{" "}
          {university.courses.map((ele) => ele.course).join(", ")}
         </Text>
         <Box background={"black"} color={"white"} textAlign={"start"} p={1}>
          <Text fontSize={{ base: "0.6rem", lg: "1rem" }}>
           <strong>Fees Offered:</strong>{" "}
           {university.courses.find(
            (c) =>
             c.course === "MBBS" ||
             "Various Undergraduate, Graduate, and Postgraduate Programs"
           )?.tuitionFee || "N/A"}
          </Text>
         </Box>
        </Box>
       </VStack>

       <VStack>
        <Button
         width={"10vw"}
         fontSize={{ base: "0.6rem", lg: "1rem" }}
         borderRadius={"10px"}
         height={"4vh"}
         mt={4}
         border={"2px solid #01B4EC"}
         cursor={"pointer"}
         onClick={() =>
          navigate(`/college-details/${country}/${university.id}`)
         }
         _hover={{ backgroundColor: "#01B4EC" }}
        >
         Details
        </Button>
       </VStack>
      </HStack>

      <HStack>
       <Box mt={4} fontSize={{ base: "0.6rem", lg: "1rem" }}>
        <Flex>
         {["About", "Courses", "Cut Off", "Admission", "Qna"].map(
          (item, idx) => (
           <React.Fragment key={idx}>
            <Text ml={"30"} mr={"30"}>
             {item}
            </Text>
            {idx < 4 && <Box w="2px" h="1.3rem" bg="black" />}
           </React.Fragment>
          )
         )}
        </Flex>
       </Box>
      </HStack>
     </Box>
    </Box>
   ))}
  </Box>
 );
};

export default CollegeList;

// // components/CollegeList.jsx
// import React from "react";
// import {
//  Box,
//  Text,
//  HStack,
//  VStack,
//  Image,
//  Flex,
//  Icon,
//  Button,
// } from "@chakra-ui/react";
// import { MdPlace } from "react-icons/md";
// import { useNavigate, useParams } from "react-router-dom";

// const CollegeList = ({ collegeData }) => {
//  const { country } = useParams();
//  const navigate = useNavigate();

//  return (
//   <Box>
//    {collegeData.map((university) => (
//     <Box
//      key={university.id}
//      display={"flex"}
//      flexDirection={"column"}
//      alignItems={"center"}
//      justifyContent={"center"}
//      marginBottom={"4vh"}
//      marginLeft={{ lg: "1vw" }}
//      marginTop={4}
//     >
//      <Box
//       borderWidth="1px"
//       border={"2px solid #01B4EC"}
//       borderRadius="35px"
//       overflow="hidden"
//       p={4}
//       bg="white"
//       width={{ base: "100vw", lg: "70vw" }}
//       margin={"auto"}
//       position={"relative"}
//       fontFamily={"Lato"}
//       cursor={"pointer"}
//       boxShadow="rgba(0, 0, 0, 0.7) 5px 7px 8px"
//       transition="transform 0.3s ease"
//       _hover={{
//        transform: "translate(15px, 15px)",
//       }}
//      >
//       <HStack>
//        <VStack ml={{ base: "1vw", lg: "3vw" }}>
//         <Image
//          src={university.image2 || "https://via.placeholder.com/150"}
//          alt={university.collegename}
//          boxSize="150px"
//          objectFit="cover"
//         />
//        </VStack>

//        <VStack width={"45vw"} textAlign={"center"}>
//         <Text
//          color={"#01B4EC"}
//          fontSize={{ base: "0.8rem", lg: "1rem" }}
//          fontWeight="bold"
//         >
//          {university.collegename}
//         </Text>
//         <Flex
//          align="center"
//          fontSize={{ base: "0.7rem", lg: "1rem" }}
//          color={"black"}
//          fontWeight={"200"}
//          opacity={"0.7"}
//         >
//          <Icon as={MdPlace} boxSize={30} />
//          <Text>{university.address},</Text>
//          <Text ml={1}>{university.state}</Text>
//         </Flex>
//         <Box bg="gray.200" p={2} borderRadius="md">
//          <Text fontSize={{ base: "0.6rem", lg: "1rem" }} textAlign={"start"}>
//           <strong>Courses Offered:</strong>{" "}
//           {university.courses.map((ele) => ele.course).join(", ")}
//          </Text>
//          <Box background={"black"} color={"white"} textAlign={"start"} p={1}>
//           <Text fontSize={{ base: "0.6rem", lg: "1rem" }}>
//            <strong>Fees Offered:</strong>{" "}
//            {university.courses.find(
//             (c) =>
//              c.course === "MBBS" ||
//              "Various Undergraduate, Graduate, and Postgraduate Programs"
//            )?.tuitionFee || "N/A"}
//           </Text>
//          </Box>

//          {/* <Box background={"black"} color={"white"} textAlign={"start"} p={1}>
//           <Text fontSize={{ base: "0.6rem", lg: "1rem" }}>
//            <strong>Fees Offered:</strong> N/A
//           </Text>
//          </Box> */}
//         </Box>
//        </VStack>

//        <VStack>
//         <Button
//          width={"10vw"}
//          fontSize={{ base: "0.6rem", lg: "1rem" }}
//          borderRadius={"10px"}
//          height={"4vh"}
//          mt={4}
//          border={"2px solid #01B4EC"}
//          cursor={"pointer"}
//          //  onClick={() => navigate(`/college-details/${university.id}`)}
//          onClick={() =>
//           navigate(`/college-details/${country}/${university.id}`)
//          }
//          _hover={{ backgroundColor: "#01B4EC" }}
//         >
//          Details
//         </Button>
//        </VStack>
//       </HStack>

//       <HStack>
//        <Box mt={4} fontSize={{ base: "0.6rem", lg: "1rem" }}>
//         <Flex>
//          {["About", "Courses", "Cut Off", "Admission", "Qna"].map(
//           (item, idx) => (
//            <React.Fragment key={idx}>
//             <Text ml={"30"} mr={"30"}>
//              {item}
//             </Text>
//             {idx < 4 && <Box w="2px" h="1.3rem" bg="black" />}
//            </React.Fragment>
//           )
//          )}
//         </Flex>
//        </Box>
//       </HStack>
//      </Box>
//     </Box>
//    ))}
//   </Box>
//  );
// };

// export default CollegeList;
